var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIntegrationAccounting = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.147 76.513c-3.802-.693-2.16-4.476-.864-6.28l.864-1.083 9.29 3.898c-1.513 1.444-5.488 4.158-9.29 3.465z",
    fill: "#AF8EE9",
    stroke: "#040222",
    strokeWidth: 0.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.857 58.105l19.443 6.28c-4.537.65-8.21 2.383-9.937 4.548-3.588 4.496-2.694 6.507-1.455 7.155l.59.209a2.218 2.218 0 01-.59-.209c-2.831-1.006-15.46-5.56-30.316-11.703-.691-3.811-2.304-13.127 0-14.282l22.265 8.002z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.638 78.896c-5.185 0-19.73-5.775-26.356-8.663.864-1.733 4.278-5.328 11.018-5.847 2.52.794 7.95 2.512 9.505 3.032 1.944.65 4.105-3.899 7.777-4.115 3.673-.217 5.185.65 7.13.65 1.448 0 1.512.866 1.296 1.082-.216.217.216 1.083-3.24.867-3.457-.217-5.402.65-5.618 1.516-.216.866-.648 1.516.432 1.949.864.346 5.73 1.03 8.106 1.464.602-.633 1.105-1.17 1.4-1.464 1.08-1.083 2.376-.867 2.376-.217 0 .046-.02.12-.06.217.589-.867 1.572-1.3 2.652-1.3.373 0 .437.259.334.65.25-.433 1.049-1.3 2.259-1.3.681 0 .66.573.373 1.3.236-.505.923-1.473 1.787-1.3 1.08.217.432 1.084.216 1.95-.216.866-3.024 6.064-4.104 6.93-.865.693-2.161.578-2.702.433-.283.306-.558.535-.814.65-1.163.52-2.317.226-2.75.014-.457.41-.899.712-1.296.843-1.555.513-3.096.214-3.672 0-1.221.383-3.061.659-6.049.659z",
    fill: "#C693AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.91 74.998c1.296.433 5.617.65 6.913.216.399-.133 1.043-.636 1.776-1.3m-.912 4.323c-1.221.383-3.061.659-6.049.659-5.185 0-19.73-5.775-26.356-8.663.864-1.733 4.278-5.328 11.018-5.847 2.52.794 7.95 2.512 9.505 3.032 1.944.65 4.105-3.899 7.777-4.115 3.673-.217 5.185.65 7.13.65 1.448 0 1.512.866 1.296 1.082-.216.217.216 1.083-3.24.867-3.457-.217-5.402.65-5.618 1.516-.216.866-.648 1.516.432 1.949.864.346 5.73 1.03 8.106 1.464m-4.001 7.406c1.428-.447 2.01-1.04 2.592-1.507 1.004-.805 4.617-6.095 5.125-7.363m-7.717 8.87c.576.214 2.117.513 3.672 0 .397-.13.84-.433 1.297-.843m2.748-8.027a.678.678 0 00.06-.217c0-.65-1.296-.866-2.376.217-.552.553-1.836 1.953-3.133 3.248m5.45-3.248c.588-.867 1.571-1.3 2.651-1.3.373 0 .437.259.334.65m0 0c-.195.743-.99 1.965-1.414 2.816-.516 1.034-2.537 4.263-4.32 5.86m5.734-8.676c.25-.433 1.049-1.3 2.259-1.3.681 0 .66.573.373 1.3m-8.366 8.677c.432.212 1.586.506 2.748-.014.257-.115.532-.344.815-.65m0 0c1.322-1.427 2.816-4.522 3.35-5.414.356-.595 1.103-1.712 1.453-2.599M68.22 76.73c.54.144 1.837.26 2.702-.433 1.08-.866 3.888-6.064 4.104-6.93.216-.867.864-1.733-.216-1.95-.864-.173-1.551.795-1.787 1.3m-18.304 4.765c1.4.144 4.537.433 5.88.433m0 0c.433-.392.896-.84 1.357-1.3m-3.348-.433l3.348.433",
    stroke: "#040222",
    strokeWidth: 0.967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.675 50.065c.478.198.869.73.974 1.558l.413 3.246-4.787-2.044-.413-3.246c-.105-.827-.496-1.36-.973-1.557l4.786 2.043zM53.73 39.262c2.654-2.018 4.436-6.319 4.016-9.628-.21-1.655-.929-2.728-1.948-3.116l4.786 2.043c1.02.388 1.746 1.525 1.948 3.116.42 3.31-1.361 7.61-4.015 9.629-1.359 1.013-2.623 1.239-3.643.85l-4.787-2.043c1.02.388 2.348.155 3.643-.85zM60.954 18.232l2.59-2.01 4.787 2.043-2.654 2.018c-.652.471-1.28.616-1.822.426l-4.786-2.044c.541.19 1.233.038 1.885-.433z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.468 49.56l-4.787-2.043c.464 1.105 1.047 2.13 1.788 2.877l4.787 2.043a7.58 7.58 0 01-1.788-2.877zM62.587 15.825l-4.786-2.043c-1.027.066-2.164.275-3.27.738l4.787 2.044c1.113-.4 2.18-.665 3.27-.739z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 0.967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.217 43.83c.8-1.848.558-3.758-.533-4.201l4.786 2.043c1.091.444 1.334 2.353.534 4.2l-1.592 3.76-4.787-2.043 1.592-3.76zM51.345 20.487c.588-.463 1.2-1.252 1.603-2.144l1.529-3.75 4.786 2.043-1.528 3.75c-.396.956-.952 1.674-1.603 2.145-.588.462-1.28.615-1.822.425l-4.786-2.043c.541.19 1.17.045 1.821-.426z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.097 35.961l-4.787-2.043c-.378 1.6-.685 3.256-.81 4.824l4.787 2.043c.124-1.568.376-3.152.81-4.824z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 0.967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.901 31.907c1.295-1.005 2.19-3.124 1.98-4.778l-.412-3.246 4.786 2.043.413 3.246c.21 1.655-.685 3.773-1.98 4.779l-2.654 2.018-4.786-2.043 2.653-2.019z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.184 21.997l-4.787-2.043a29.215 29.215 0 00-2.864 3.92l4.786 2.044a28.94 28.94 0 012.865-3.92z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 0.967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.004 45.873l-1.592 3.759c.464 1.105 1.047 2.13 1.788 2.877l2.59-2.01c1.295-1.006 2.586-.523 2.796 1.132l.412 3.246a10.691 10.691 0 003.333-.747l1.536-3.688c.396-.955.952-1.672 1.603-2.143.588-.463 1.28-.616 1.822-.426l2.118.895c1.072-1.235 2.008-2.518 2.929-3.929l-.413-3.246c-.21-1.654.685-3.773 1.98-4.778l2.59-2.01c.38-1.601.686-3.257.81-4.825l-2.182-.887c-1.091-.443-1.334-2.352-.534-4.2l1.592-3.76c-.472-1.168-1.046-2.13-1.788-2.876l-2.654 2.018c-1.295 1.006-2.585.523-2.795-1.132l-.413-3.246c-1.026.066-2.163.275-3.269.739l-1.528 3.75c-.396.957-.951 1.674-1.603 2.145-.588.462-1.28.615-1.822.425l-2.182-.887a29.206 29.206 0 00-2.864 3.921l.412 3.246c.21 1.655-.685 3.773-1.98 4.779l-2.654 2.018c-.378 1.6-.685 3.256-.81 4.824l2.175.823c1.154.436 1.389 2.281.597 4.193zm11.577-4.575c-2.654 2.018-5.179.981-5.599-2.329-.42-3.309 1.361-7.61 4.015-9.628 2.654-2.019 5.179-.982 5.599 2.328.42 3.31-1.361 7.61-4.015 9.629z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h104.501v103.126H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIntegrationAccounting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/integration-accounting.921d671ce0762c9ff0bc481f10403c45.svg";